module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('panel', {
    staticClass: "announcement"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  })], 1) : _c('panel', {
    attrs: {
      "title": ((_vm.announcement.code) + " - " + (_vm.announcement.title)),
      "withFooter": false,
      "withBody": _vm.withBody
    }
  }, [_c('div', {
    staticClass: "header-right",
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('span', {
    staticClass: "badge",
    class: _vm.announcement.statusSynchronization
  }, [_vm._v(_vm._s(_vm.$t(("mercadoLivre.migration.statusSynchronization." + (_vm.announcement.statusSynchronization) + ".label"))))]), _vm._v(" "), _c('span', {
    staticClass: "badge announcement-status",
    class: _vm.announcement.status
  }, [_vm._v(_vm._s(_vm.$t(("mercadoLivre.migration." + (_vm.announcement.status) + ".label"))))]), _vm._v(" "), (_vm.announcement.status == 'pending') ? _c('button', {
    staticClass: "btn btn--danger u-floatRight",
    on: {
      "click": _vm.deleteProductMigration
    }
  }, [_vm._v("Cancelar migração")]) : _vm._e()]), _vm._v(" "), (_vm.details) ? _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-2@md vertical-center"
  }, [(_vm.image) ? _c('img', {
    staticClass: "photo",
    attrs: {
      "src": _vm.image,
      "alt": _vm.details.title
    }
  }) : _c('i', {
    staticClass: "icon icon-image2 no-photo"
  })]), _vm._v(" "), _c('div', {
    staticClass: "l-col-10@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('form-group', {
    attrs: {
      "label": "Módulo",
      "columns": 12
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.moduleSelect),
      expression: "moduleSelect"
    }],
    staticClass: "form-select",
    attrs: {
      "disabled": _vm.details.migration.done
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.moduleSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.modules), function(module) {
    return _c('option', {
      domProps: {
        "value": ((module.type) + "." + (module.identifier))
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t(((module.type) + ".label"))) + " " + _vm._s(_vm.$t(((module.identifier) + ".label"))) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Produto",
      "columns": 12
    }
  }, [_c('multiselect', {
    attrs: {
      "multiple": false,
      "options": _vm.products,
      "open-direction": "bottom",
      "placeholder": "Buscar por título/sku/ean/referencia",
      "label": "name",
      "track-by": "name",
      "loading": _vm.isLoading,
      "disabled": !_vm.moduleSelect || !_vm.details.source.type || _vm.details.migration.done,
      "searchable": true,
      "internal-search": false,
      "clear-on-select": true,
      "close-on-select": true,
      "show-labels": false,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": true,
      "selectLabel": "Clique",
      "selectedLabel": ""
    },
    on: {
      "search-change": _vm.searchMethod
    },
    model: {
      value: (_vm.product),
      callback: function($$v) {
        _vm.product = $$v
      },
      expression: "product"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.product) ? _c('div', {
    staticClass: "l-col-12@md"
  }, [_vm._v("\n          " + _vm._s(_vm.details.variationsCombination ? 'Variações' : 'Variação') + "\n\n          "), _vm._l((_vm.details.variations), function(announcementVariation) {
    return (_vm.details.variationsCombination) ? _c('announcement-migration-with-variation', {
      key: announcementVariation,
      attrs: {
        "announcementVariation": announcementVariation,
        "productVariations": _vm.product.variations,
        "migration": _vm.details.migration,
        "announcementHasOnlyOneVariation": _vm.details.variations.length === 1
      }
    }) : _vm._e()
  }), _vm._v(" "), (!_vm.details.variationsCombination) ? _c('announcement-migration-without-variation', {
    attrs: {
      "announcementVariation": _vm.details.variations[0],
      "productVariations": _vm.product.variations,
      "migration": _vm.details.migration
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn--info u-floatRight",
    class: {
      'is-loading': _vm.isMigrationDoing
    },
    attrs: {
      "disabled": _vm.details.migration.done && _vm.details.variations.length === _vm.details.migration.variations.length
    },
    on: {
      "click": _vm.migrateAnnouncement
    }
  }, [_vm._v(_vm._s(_vm.$t('migrate.label')))])], 2) : _vm._e()])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17ccaeb7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/AnnouncementMigrationCard.vue
// module id = 2942
// module chunks = 0